import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { Lock, Eye, EyeOff, ArrowRight, CheckCircle } from '../components/Icons';
import logo from '../assets/logo.png';

function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      setError('Password minimal 6 karakter.');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError(error.message);
    } else {
      setDone(true);
    }
    setLoading(false);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoRow} onClick={() => navigate('/landing')}>
          <img src={logo} alt="NOWGUT" style={styles.logoImg} />
          <div style={styles.logoName}>NOWGUT</div>
        </div>

        {done ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <CheckCircle size={48} color="var(--teal-primary)" strokeWidth={1.5} />
            <h1 style={styles.title}>Password berhasil diubah!</h1>
            <p style={styles.subtitle}>Silakan login dengan password baru Anda.</p>
            <button className="btn-primary-animated" style={styles.btnPrimary}
              onClick={() => navigate('/login')}>
              Lanjut ke Login <ArrowRight size={16} />
            </button>
          </div>
        ) : (
          <>
            <h1 style={styles.title}>Buat Password Baru</h1>
            <p style={styles.subtitle}>Masukkan password baru Anda di bawah ini.</p>
            {error && <div style={styles.errorBox}>⚠️ {error}</div>}
            <form onSubmit={handleReset}>
              <div style={styles.field}>
                <label style={styles.label}>Password Baru</label>
                <div style={styles.inputWrapper}>
                  <Lock size={16} style={styles.inputIcon} color="var(--body-mid)" />
                  <input
                    style={styles.inputWithIcon}
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Min. 6 karakter"
                    required />
                  <button type="button" style={styles.eyeBtn}
                    onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <EyeOff size={16} color="var(--body-mid)" /> : <Eye size={16} color="var(--body-mid)" />}
                  </button>
                </div>
              </div>
              <button type="submit" className="btn-primary-animated"
                style={styles.btnPrimary} disabled={loading}>
                {loading ? 'Menyimpan...' : 'Simpan Password'}
                {!loading && <ArrowRight size={16} strokeWidth={2} />}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'var(--canvas-soft)', padding: '24px 16px' },
  card: { backgroundColor: 'var(--canvas)', padding: '40px', borderRadius: 'var(--radius-md)', width: '100%', maxWidth: '420px', border: '1px solid var(--teal-light)', boxShadow: 'var(--shadow-lg)' },
  logoRow: { display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '28px', cursor: 'pointer' },
  logoImg: { height: '32px', width: 'auto' },
  logoName: { fontSize: '15px', fontWeight: '800', color: 'var(--teal-primary)', letterSpacing: '0.05em' },
  title: { fontSize: '22px', fontWeight: '700', color: 'var(--ink)', marginBottom: '8px' },
  subtitle: { fontSize: '14px', color: 'var(--body)', lineHeight: '1.6', marginBottom: '24px' },
  errorBox: { backgroundColor: '#FEF2F2', color: '#DC2626', padding: '12px', borderRadius: 'var(--radius-sm)', marginBottom: '16px', fontSize: '13px', border: '1px solid #FECACA' },
  field: { marginBottom: '16px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: 'var(--ink)', marginBottom: '6px' },
  inputWrapper: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputIcon: { position: 'absolute', left: '12px', pointerEvents: 'none' },
  inputWithIcon: { width: '100%', padding: '12px 42px', borderRadius: 'var(--radius-sm)', border: '1.5px solid var(--teal-light)', fontSize: '15px', boxSizing: 'border-box', backgroundColor: 'var(--canvas)', color: 'var(--ink)', fontFamily: 'inherit' },
  eyeBtn: { position: 'absolute', right: '12px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center' },
  btnPrimary: { width: '100%', padding: '14px', backgroundColor: 'var(--primary)', color: 'var(--on-primary)', border: 'none', borderRadius: 'var(--radius-md)', fontSize: '16px', fontWeight: '700', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 12px rgba(226,120,48,0.3)' },
};

export default ResetPassword;